/* ============ Doli London — Wishlist (adds to Dawn without touching its logic) ============ */
(function () {
  'use strict';

  var WISHLIST_KEY = 'doli_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('doli:wishlist-updated', { detail: { count: list.length } }));
  }
  function isWishlisted(handle) {
    return getWishlist().some(function (i) { return i.handle === handle; });
  }
  function toggleWishlist(item) {
    var list = getWishlist();
    var exists = list.some(function (i) { return i.handle === item.handle; });
    if (exists) {
      list = list.filter(function (i) { return i.handle !== item.handle; });
    } else {
      list.push(item);
    }
    saveWishlist(list);
    return !exists;
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-dp-wishlist-btn]').forEach(function (btn) {
      if (btn.dataset.doliInit) return; // avoid double-binding
      btn.dataset.doliInit = 'true';

      var handle = btn.getAttribute('data-handle');
      if (isWishlisted(handle)) btn.classList.add('is-active');

      btn.addEventListener('click', function () {
        var item = {
          handle: handle,
          title: btn.getAttribute('data-title'),
          price: btn.getAttribute('data-price'),
          image: btn.getAttribute('data-image'),
          url: btn.getAttribute('data-url')
        };
        var added = toggleWishlist(item);
        btn.classList.toggle('is-active', added);
      });
    });
  }

  function updateWishlistCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-dp-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  document.addEventListener('doli:wishlist-updated', updateWishlistCountBadges);
  document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons();
    updateWishlistCountBadges();
  });

  // In case this section re-renders via Shopify's theme editor / variant swap,
  // re-scan for any new wishlist buttons that may have appeared.
  document.addEventListener('shopify:section:load', initWishlistButtons);
})();
